import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-2xl mx-auto text-center">
        
        {/* Illustration/Number */}
        <div className="mb-8">
          <div className="text-9xl font-bold text-gray-200 mb-4">404</div>
          <div 
            className="w-32 h-2 rounded-full mx-auto mb-6"
            style={{ backgroundColor: 'var(--primary)' }}
          ></div>
        </div>

        {/* Message */}
        <h1 className="text-4xl md:text-5xl font-light mb-6 text-gray-800">
          Sidan kunde inte hittas
        </h1>
        
        <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-md mx-auto">
          Ojdå! Den sidan du letar efter verkar ha försvunnit. 
          Kanske har den flyttats eller så har du skrivit in fel adress.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Link
            to="/"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full text-lg font-semibold text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            style={{ backgroundColor: 'var(--primary)' }}
          >
            <Home className="w-5 h-5" />
            Till startsidan
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full text-lg font-semibold border-2 hover:shadow-lg transition-all duration-300"
            style={{ borderColor: 'var(--secondary)', color: 'var(--secondary)' }}
          >
            <ArrowLeft className="w-5 h-5" />
            Gå tillbaka
          </button>
        </div>

        {/* Quick Links */}
        <div className="border-t pt-8">
          <p className="text-gray-500 mb-4">Här är några populära sidor:</p>
          <div className="flex flex-wrap justify-center gap-6">
            <Link
              to="/behandlingar"
              className="text-gray-600 hover:text-[var(--primary)] transition-colors duration-200"
            >
              Behandlingar
            </Link>
            <Link
              to="/personal" 
              className="text-gray-600 hover:text-[var(--primary)] transition-colors duration-200"
            >
              Personal
            </Link>
            <Link
              to="/bilder"
              className="text-gray-600 hover:text-[var(--primary)] transition-colors duration-200"
            >
              Bilder
            </Link>
            <Link
              to="/om-oss"
              className="text-gray-600 hover:text-[var(--primary)] transition-colors duration-200"
            >
              Om Oss
            </Link>
          </div>
        </div>

        {/* Contact Info */}
        <div className="mt-8 p-6 bg-gray-50 rounded-2xl max-w-md mx-auto">
          <p className="text-gray-600 mb-2">Behöver du hjälp?</p>
          <p className="text-sm text-gray-500">
            Ring oss på{" "}
            <a href="tel:0707138005" className="text-[var(--primary)] hover:underline">
              070-713 80 05
            </a>{" "}
            eller{" "}
            <a href="mailto:salong@milepa.se" className="text-[var(--primary)] hover:underline">
              salong@milepa.se
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}